import React, { useCallback, useEffect, useRef, useState } from 'react';
import './WishListPage.css';
import ItemGrid from '../HomePage/ItemGrid';
import { Item } from '../../common/Rest/Services/Data';
import wishListService from '../../common/Rest/Services/WishListService/WishListService';
import { CircularProgress, Typography } from '@mui/material';

const PAGE_SIZE = 12;

function WishListPage() {
  const [items, setItems] = useState<Item[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [pageIndex, setPageIndex] = useState(0);
  const didInitialLoad = useRef(false);

  const loadPage = useCallback(async () => {
    if (loading || !hasMore) return;
    setLoading(true);

    try {
      const skip = pageIndex * PAGE_SIZE;
      const response = await wishListService.GetWishList(skip, PAGE_SIZE);
      setItems((prev) => [...prev, ...response.items]);
      setHasMore(skip + response.items.length < response.totalCount);
      setPageIndex((prev) => prev + 1);
    } catch (err) {
      console.error('Помилка завантаження вішліста:', err);
    } finally {
      setLoading(false);
    }
  }, [pageIndex, loading, hasMore]);

  useEffect(() => {
    if (didInitialLoad.current) return;
    didInitialLoad.current = true;
    loadPage();
  }, [loadPage]);

  const observer = useRef<IntersectionObserver | null>(null);
  const lastItemRef = useCallback(
    (node: HTMLLIElement | null) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          loadPage();
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore, loadPage]
  );

  return (
    <div className="wish-list default-container">
      <div className="wish-list-heading">
        <Typography variant="h4">Вішліст</Typography>
        <Typography color="text.secondary">Книжки, які ви зберегли на потім.</Typography>
      </div>

      {items.length > 0 && <ItemGrid items={items} gridColumns={3} lastItemRef={lastItemRef} />}
      {loading && <CircularProgress sx={{ display: 'block', margin: '24px auto' }} />}
      {!loading && items.length === 0 && <div className="empty-message">Вішліст порожній</div>}
      {!hasMore && items.length > 0 && <div className="end-message">Це всі збережені книжки</div>}
    </div>
  );
}

export default WishListPage;
